import styled from "styled-components/native";
import {
  BackgroundColorProps,
  PaddingProps,
  paddingProps,
  backgroundColorProps,
} from "@sloth-system/props";

export { PageContainerShape };

export type BoxProps = BackgroundColorProps & PaddingProps;

let PageContainerShape = styled.View<BoxProps>`
  ${paddingProps}
  ${backgroundColorProps}
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  flex: 1;
`;
